import type { DateRange, IsoDate } from "../../../common/src";
import { rangeLengthDays } from "../../../common/src";

const dateFormat = new Intl.DateTimeFormat(undefined, {
  weekday: "short",
  month: "short",
  day: "numeric",
  year: "numeric",
  timeZone: "UTC",
});

const monthFormat = new Intl.DateTimeFormat(undefined, {
  month: "long",
  year: "numeric",
  timeZone: "UTC",
});

const toUtcDate = (date: IsoDate): Date => new Date(`${date}T00:00:00Z`);

export const formatDate = (date: IsoDate): string =>
  dateFormat.format(toUtcDate(date));

export const formatMonth = (firstDay: IsoDate): string =>
  monthFormat.format(toUtcDate(firstDay));

export const formatRange = (range: DateRange): string =>
  range.startDate === range.endDate
    ? formatDate(range.startDate)
    : `${formatDate(range.startDate)} – ${formatDate(range.endDate)}`;

export const formatDays = (range: DateRange): string => {
  const days = rangeLengthDays(range);
  return `${days} day${days === 1 ? "" : "s"}`;
};

export const formatTimestamp = (date: Date): string =>
  date.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
